"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var classnames = require("classnames");
var TICK_TIMEOUT = 50;
function isBecomeDisplay(prevProps, props) {
    return ((!prevProps.children && !!props.children) ||
        (prevProps.displayed === false && props.displayed === true));
}
function isBecomeHide(prevProps, props) {
    return ((!!prevProps.children && !props.children) ||
        ((prevProps.displayed === undefined || prevProps.displayed === true) &&
            props.displayed === false));
}
function getDuration(duration, key) {
    if (typeof duration === 'number') {
        return duration;
    }
    return duration[key];
}
function isChildrenDisplayed(_a) {
    var children = _a.children, displayed = _a.displayed;
    return !!children && displayed !== false;
}
function getChildrenClassName(children) {
    if (children && children.props) {
        return children.props.className;
    }
    return undefined;
}
var CssTransition = /** @class */ (function (_super) {
    tslib_1.__extends(CssTransition, _super);
    function CssTransition(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.enterDelay = null;
        _this.exitDelay = null;
        _this.enterTimeout = null;
        _this.exitTimeout = null;
        var classNames = props.classNames, animateOnMount = props.animateOnMount;
        var children = isChildrenDisplayed(props) ? props.children : null;
        var childrenClassName = children && children.props ? children.props.className : undefined;
        var className = classnames(childrenClassName, (_a = {},
            _a[classNames.enter] = animateOnMount,
            _a));
        _this.state = { children: children, className: className };
        return _this;
    }
    CssTransition.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, children = _a.children, animateOnMount = _a.animateOnMount, delay = _a.delay, timeout = _a.timeout, classNames = _a.classNames;
        if (animateOnMount) {
            var childrenClassName_1 = getChildrenClassName(children);
            var delayDuration = getDuration(delay, 'enter');
            var timeoutDuration_1 = getDuration(timeout, 'enter');
            this.enterDelay = window.setTimeout(function () {
                var enterActiveClassName = classnames(childrenClassName_1, classNames.enter, classNames.enterActive);
                _this.setState({ className: enterActiveClassName });
                _this.enterDelay = null;
                _this.enterTimeout = window.setTimeout(function () {
                    _this.setState({ className: childrenClassName_1 });
                    _this.enterTimeout = null;
                }, timeoutDuration_1 + TICK_TIMEOUT);
            }, delayDuration + TICK_TIMEOUT);
        }
    };
    CssTransition.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var _a = this.props, children = _a.children, classNames = _a.classNames, delay = _a.delay, timeout = _a.timeout;
        if (isBecomeDisplay(prevProps, this.props)) {
            var childrenClassName_2 = getChildrenClassName(children);
            var delayDuration_1 = getDuration(delay, 'enter');
            var timeoutDuration_2 = getDuration(timeout, 'enter');
            var enterClassName_1 = classnames(childrenClassName_2, classNames.enter);
            this.setState({ children: this.props.children, className: enterClassName_1 }, function () {
                if (_this.exitDelay) {
                    window.clearTimeout(_this.exitDelay);
                    _this.exitDelay = null;
                }
                if (_this.exitTimeout) {
                    window.clearTimeout(_this.exitTimeout);
                    _this.exitTimeout = null;
                }
                _this.enterDelay = window.setTimeout(function () {
                    var enterActiveClassName = classnames(enterClassName_1, classNames.enterActive);
                    _this.setState({ className: enterActiveClassName });
                    _this.enterDelay = null;
                    _this.enterTimeout = window.setTimeout(function () {
                        _this.setState({ className: childrenClassName_2 });
                        _this.enterTimeout = null;
                    }, timeoutDuration_2 + TICK_TIMEOUT);
                }, delayDuration_1 + TICK_TIMEOUT);
            });
            return;
        }
        if (isBecomeHide(prevProps, this.props)) {
            var childrenClassName_3 = getChildrenClassName(this.state.children);
            var delayDuration_2 = getDuration(delay, 'exit');
            var timeoutDuration_3 = getDuration(timeout, 'exit');
            var exitClassName_1 = classnames(childrenClassName_3, classNames.exit);
            this.setState({ className: exitClassName_1 }, function () {
                if (_this.enterDelay) {
                    window.clearTimeout(_this.enterDelay);
                    _this.enterDelay = null;
                }
                if (_this.enterTimeout) {
                    window.clearTimeout(_this.enterTimeout);
                    _this.enterTimeout = null;
                }
                _this.exitDelay = window.setTimeout(function () {
                    var exitActiveClassName = classnames(exitClassName_1, classNames.exitActive);
                    _this.setState({ className: exitActiveClassName });
                    _this.exitDelay = null;
                    _this.exitTimeout = window.setTimeout(function () {
                        _this.setState({ children: null, className: childrenClassName_3 });
                        _this.exitTimeout = null;
                    }, timeoutDuration_3 + TICK_TIMEOUT);
                }, delayDuration_2 + TICK_TIMEOUT);
            });
            return;
        }
        if (isChildrenDisplayed(this.props) && this.state.children !== children) {
            this.setState(function (state) {
                var propClassName = getChildrenClassName(children);
                var stateClassName = getChildrenClassName(state.children);
                if (propClassName !== stateClassName) {
                    return { children: children, className: propClassName };
                }
                return { children: children };
            });
        }
    };
    CssTransition.prototype.componentWillUnmount = function () {
        if (this.enterDelay) {
            window.clearTimeout(this.enterDelay);
            this.enterDelay = null;
        }
        if (this.enterTimeout) {
            window.clearTimeout(this.enterTimeout);
            this.enterTimeout = null;
        }
        if (this.exitDelay) {
            window.clearTimeout(this.exitDelay);
            this.exitDelay = null;
        }
        if (this.exitTimeout) {
            window.clearTimeout(this.exitTimeout);
            this.exitTimeout = null;
        }
    };
    CssTransition.prototype.render = function () {
        var _a = this.state, children = _a.children, className = _a.className;
        if (children && children.props) {
            return react_1.cloneElement(children, { className: className });
        }
        return children;
    };
    CssTransition.defaultProps = {
        animateOnMount: false,
        delay: 0,
    };
    return CssTransition;
}(react_1.Component));
exports.default = CssTransition;
